module.exports = __webpack_public_path__ + "img/classic@2x.7ede502.jpg";